import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business, notices, schedule } from '../data/business';
import { PapelPicado } from './PapelPicado';
import { TricolorStripe } from './TricolorStripe';
export function SiteFooter() {
  return <footer id="hours" className="w-full bg-verde text-white" data-id="element-59" data-mp="3mfq0yew1y4d7">
      <div className="bg-paper pt-6" data-id="element-60" data-mp="3hj7yjlo72i41">
        <PapelPicado count={24} data-id="element-61" data-mp="3hi6dcodgsf8l" />
      </div>
      <TricolorStripe className="h-1.5" data-id="element-62" data-mp="3dhe1roh4dy95" />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-63" data-mp="3difncmvri354">
        <div data-id="element-64" data-mp="38juoaqs8xpi9">
          <p className="font-display text-4xl leading-tight" data-id="element-65" data-mp="38k4eaedajwny">¿Tienes hambre?</p>
          <p className="mt-1 text-lg text-white/80" data-id="element-66" data-mp="33ix468noele4">Hungry? Give us a call — we'll get it going.</p>
          <a href={business.phoneHref} className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-salsa px-6 py-3 text-lg font-bold text-white hover:bg-salsa-dark transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-verde" data-id="element-67" data-mp="2yleycr4ygmac">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="1aqq2zek83t5j" />
            {business.phoneDisplay}
          </a>
        </div>

        <div data-id="element-69" data-mp="vusaq7df78yl">
          <h2 className="font-display text-2xl" data-id="element-70" data-mp="10rseucqpm1n2">Horario</h2>
          <dl className="mt-3 space-y-1.5 text-sm" data-id="element-71" data-mp="10sai3tbshg4h">
            {schedule.map(s => <div key={s.day} className="flex justify-between gap-4" data-id="element-72" data-mp="1oio00r0ntylc">
                <dt className="text-white/75" data-id="element-73" data-mp="1tgzexg5tazaf">{s.day}</dt>
                <dd className="font-semibold" data-id="element-74" data-mp="1tiiq4scm2k5c">{s.hours}</dd>
              </div>)}
          </dl>
        </div>

        <div data-id="element-75" data-mp="1jqmqhcuvmlz0">
          <h2 className="font-display text-2xl" data-id="element-76" data-mp="1jq4mtv5vx5h2">Good to know</h2>
          <ul className="mt-3 space-y-2 text-sm text-white/85" data-id="element-77" data-mp="1joa2oj2fthe1">
            {notices.map(n => <li key={n} data-id="element-78" data-mp="27ee5wpbprf4i">{n}</li>)}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15 bg-verde-dark" data-id="element-79" data-mp="2c90iuwxg1fqp">
        <p className="mx-auto max-w-6xl px-4 py-5 text-xs text-white/70 sm:px-6" data-id="element-80" data-mp="2m1v101zkbq16">
          © {new Date().getFullYear()} Oh My Tacos · ¡Buen provecho!
        </p>
        <p className="mx-auto max-w-6xl px-4 pb-4 text-xs text-white/70 sm:px-6" data-id="element-81" data-mp="2d27zlg6u2k84">
          Pipe check 10/16
        </p>
      </div>
    </footer>;
}